import { h } from "preact";

import classname from "../../../foundation/utils/classname";
import { colorNames } from "../../../foundation/utils/dot";

import styles from "./DotColors.module.css";

interface DotColorProps {
    class?: string;
    color: typeof colorNames[number];
    selected?: boolean;
    onClick?(color: string): void;
}

const colorClasses: Record<typeof colorNames[number], string> = {
    yellow: styles.yellow,
    orange: styles.orange,
    peach: styles.peach,
    green: styles.green,
    turquoise: styles.turquoise,
    cornflowerBlue: styles.cornflowerBlue,
    deepPurple: styles.deepPurple
};

function DotColor({
    class: cssClass,
    color,
    selected = false,
    onClick
}: DotColorProps) {
    const classes = classname(styles.dotColor, colorClasses[color], cssClass, {
        [styles.selected]: selected
    });

    function handleClick() {
        onClick?.(color);
    }

    return (
        <div class={classes} onClick={handleClick}/>
    );
}

interface Props {
    class?: string;
    isEditing: boolean;
    selectedColor: string;
    onClick(color: string): void;
}

export default function DotColors({
    class: cssClass,
    isEditing,
    selectedColor,
    onClick
}: Props) {
    const containerClass = classname(styles.dotColorsContainer, cssClass, { [styles.editing]: isEditing });

    return (
        <div class={containerClass}>
            <div class={styles.dotColors}>
                {colorNames.map(color => (
                    <DotColor
                        key={color}
                        color={color}
                        selected={color === selectedColor}
                        onClick={onClick}/>
                ))}
            </div>
        </div>
    );
}

export { DotColor };
